/**
 * Lista atrybutów produktu, które mają przypisane ikony i są wyświetlane w komponencie Details
 * Te atrybuty powinny być odfiltrowane z listy atrybutów technicznych w komponencie Product
 * przed przekazaniem do AttributeList
 */
export const PRODUCT_ATTRIBUTES_WITH_ICONS = [
  'DO_ZAMROZENIA',
  'DO_MIKROFALOWKI',
  'DO_CIEPLYCH_PRODUKTOW',
  'TYLKO_DO_ZIMNYCH_PRODUKTOW',
  'DO_ZMYWARKI',
  'BIODEGRADOWALNE',
  'BIO', // alias dla BIODEGRADOWALNE
  'DO_RECYKLINGU',
  'POD_NADRUK',
  'Z_RECYKLINGU',
  'Z_ROSLIN',
  'DO_POSADZEK',
  'DO_SANITARIATOW',
  'NEUTRALIZACJA_ZAPACHOW_I_ODSWIEZANIE',
  'POWIERZCHNIE_SZKLANE',
  'DO_DREWNA',
  'DO_STALI_NIERDZEWNEJ',
  'DLA_GASTRONOMII',
  'DYWANY_I_WYKLADZINY',
  'PRZEMYSL',
  'DEZYNFEKCJA',
  'MYCIE_RECZNE',
  'MYCIE_MASZYNOWE',
  'MYCIE_MOPEM',
  'SPRYSKIWACZ',
  'DO_SYSTEMU_DOZOWANIA',
] as const;

/**
 * Funkcja sprawdzająca czy atrybut ma przypisaną ikonę
 */
export const hasAttributeIcon = (attributeName: string | undefined): boolean => {
  if (!attributeName) return false;
  return PRODUCT_ATTRIBUTES_WITH_ICONS.includes(attributeName as any);
};

/**
 * Funkcja filtrująca atrybuty, które mają ikony
 */
export const filterAttributesWithIcons = <T extends { name?: string }>(
  attributes: T[]
): T[] => {
  return attributes.filter((attr) => !hasAttributeIcon(attr.name));
};
